define('app-PrettyPhoto/main',['text!../libs/prettyPhoto/prettyPhoto.css', 'prettyphoto'], function (styles) {
    return {
        run: function () {
            var prettyPhotos = $("a[rel^='prettyPhoto']");

            if (prettyPhotos.length <= 0) {
                window.log("No pretty photos found, app-PrettyPhoto will not be available.");
                return;
            }

            $(document.body).append('<style>' + styles + '</style>');

            prettyPhotos.prettyPhoto({
                social_tools: false,
                show_title: false,
                deeplinking: false
            });
        }
    };
});
